import Alert from "../../../Common/Alert";
import API from "../../../Common/Network/API";
import { isLoaded, isLoading } from "../actions";

//Verify Project
export async function verifyEpic(dispatch,getUser,ideaId,handleClose,handleModalClose) {
    dispatch(isLoading());
    try {
      var response = await API.post("manage_epics.php", {
        corp: getUser.corp,
        idea_id: ideaId,
        action: "verify"
      },{},false);
      if(response.status === 'True') {
        handleClose()
        Alert("success",response.message)
      }else if( response.status === "false")
      {
        handleModalClose()
        Alert("warning",response.message)
      }
      // handleClose()
    } catch (error) {
      Alert('error',error.message);
      handleClose()
    }
    dispatch(isLoaded());
  }